import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { CameraService } from '../../../camera.service';
import { SceneBoxCalculatorService } from '../../sceneBoxCalculator.service';
import { PrintService } from '../../print.service';
import { ZoomService } from '../../../zoom.service';
import { DrawingsHolderService } from '../../drawings-holder.service';
import { DrawTitleBlockComponent } from '../../components/DrawTitleBlockComponent';
import { DrawDimensionsComponent, EditPostComponent, AddPostComponent, AddCornerPostComponent, AddPicketComponent, DrawTextComponent } from '../../components';
import { Post, SelectablePicket } from '../../object3D/Post';
import { Text } from '../../object3D';
declare let THREE: any;

@Component({
  selector: 'app-set-scale-modal',
  templateUrl: './set-scale-modal.component.html',
  styleUrls: ['./set-scale-modal.component.scss']
})
export class SetScaleModalComponent {

  private sceneBox;

  public selectedScaleIndex = 3;

  public selectedPaperSizeIndex = 0;

  public textSize = 1;

  constructor(
    private dialogRef: MatDialogRef<SetScaleModalComponent>,
    sceneBoxCalculator: SceneBoxCalculatorService,
    private cameraManager: CameraService,
    public readonly printService: PrintService,
    private zoomService: ZoomService,
    private drawingsHolder: DrawingsHolderService,
    private drawTB: DrawTitleBlockComponent,
    private drawDimensions: DrawDimensionsComponent,
    private editPostComponent: EditPostComponent,
    private addPicketComponent: AddPicketComponent,
    private addPostComponent: AddPostComponent,
    private addCornerPostComponent: AddCornerPostComponent,
    private drawTextComponent: DrawTextComponent
  ) {
    this.selectedScaleIndex = printService.selectedScaleIndex;
    this.selectedPaperSizeIndex = printService.selectedPaperSizeIndex;
    this.sceneBox = sceneBoxCalculator.calculate();
    this.textSize = this.drawDimensions.TextScale;
  }

  private updateCamera(position, scaleX, scaleY): void {
    const camera = this.cameraManager.getCamera();
    camera.position.copy(position).setY(1);
    camera.scale.set(scaleX, scaleY, 1);
    camera.updateMatrixWorld();
    camera.updateProjectionMatrix();
  }

  private setScale(center) {
    const scale = this.printService.calculateScale();
    this.updateCamera(center, scale.x, scale.x);
    this.zoomService.reset();
  }

  apply() {
    this.printService.selectedScaleIndex = this.selectedScaleIndex;
    this.printService.selectedPaperSizeIndex = this.selectedPaperSizeIndex;
    this.drawingsHolder.scale = this.printService.scales[this.selectedScaleIndex];
    this.drawingsHolder.paperWidth = this.printService.paperSizes[this.selectedPaperSizeIndex].sizeInCm.width;
    this.drawingsHolder.paperHeight = this.printService.paperSizes[this.selectedPaperSizeIndex].sizeInCm.height;
    const center = new THREE.Vector3();
    this.sceneBox.getCenter(center);
    this.printService.setPaperSize(center);
    this.setScale(center);
    this.dialogRef.close();

    if (this.drawTB.titleBlock) {
      if (this.drawTB.titleBlock && this.drawTB.titleBlock.TopBlock) {
        this.drawingsHolder.canvas.remove(this.drawTB.titleBlock.TopBlock);
        this.drawingsHolder.canvas.remove(this.drawTB.titleBlock.LeftBlock);
        this.drawingsHolder.canvas.remove(this.drawTB.titleBlock.RightBlock);
        this.drawingsHolder.canvas.remove(this.drawTB.titleBlock.LegendBlock);
        this.drawingsHolder.canvas.remove(this.drawTB.titleBlock.BottomBlock);
      }
      this.drawTB.titleBlock.update(this.drawingsHolder.scale, this.drawingsHolder.paperWidth, this.drawingsHolder.paperHeight, this.drawingsHolder.paperBox.position);
      this.drawingsHolder.canvas.add(this.drawTB.titleBlock.TopBlock);
      this.drawingsHolder.canvas.add(this.drawTB.titleBlock.LeftBlock);
      this.drawingsHolder.canvas.add(this.drawTB.titleBlock.RightBlock);
      this.drawingsHolder.canvas.add(this.drawTB.titleBlock.LegendBlock);
      this.drawingsHolder.canvas.add(this.drawTB.titleBlock.BottomBlock);

    }
    this.cameraManager.reset();
    let dimensions = this.drawingsHolder.canvas.children.filter(ch => ch.name === 'Dimensions');
    dimensions.forEach(dim => {
      let LabelDim = dim.children.filter(ch => ch.name === "LabelDim")[0];
      let Label = dim.children.filter(ch => ch.name === "Label")[0];
      LabelDim.scale.x = 30 * this.textSize;
      LabelDim.scale.y = 20 * this.textSize;
      LabelDim.scaleCor = this.textSize;

      Label.scale.x = 80 * this.textSize;
      Label.scale.z = 40 * this.textSize;
      Label.scaleCor = this.textSize;

    });
    let selPosts = this.drawingsHolder.canvas.children.filter(ch => ch instanceof Post || ch instanceof SelectablePicket || ch instanceof Text);
    this.drawingsHolder.canvas.children.forEach(ch => {
      if (ch.children) {
        let posts = ch.children.filter(ch => ch instanceof Post);
        posts.forEach(p => {
          selPosts.push(p);
        })
      }
    });
    selPosts.forEach(post => {
      post.scaleCor = this.textSize;
      post.update();
    })
    this.editPostComponent.scaleCor = this.textSize;
    this.addPicketComponent.scaleCor = this.textSize;
    this.addPostComponent.scaleCor = this.textSize;
    this.addCornerPostComponent.scaleCor = this.textSize;
    this.drawDimensions.TextScale = this.textSize;
    this.drawTextComponent.scaleCor = this.textSize;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/ng-components/set-scale-modal/set-scale-modal.component.ts